// Imports
import 'lazysizes';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';
import header from './components/header';
import eventsMap from './maps/eventsMap';
import granteeMap from './maps/granteeMap';


window.Alpine = Alpine;

// Apline plugins.
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Map features.
document.addEventListener('alpine:init', header);
document.addEventListener('alpine:init', eventsMap);
document.addEventListener('alpine:init', granteeMap);

Alpine.start();

// import Swiper JS
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay, EffectFade } from 'swiper/modules';
var swiper = new Swiper('.mySwiper', {
    modules: [Pagination,Navigation],
    speed: 1000,
    keyboard: true,
    initialSlide: 0,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 1.22,
            centeredSlides: true,
            spaceBetween: 18,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
        },
        // when window width is >= 426px
        426: {
            slidesPerView: 2.25,
            centeredSlides: false,
            spaceBetween: 30,
            slidesOffsetBefore: 22,
            slidesOffsetAfter: 16,
        },
        // when window width is >= 1024px
        1024: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 30,
            slidesOffsetBefore: 48,
            slidesOffsetAfter: 48,
        },
        // when window width is >= 1280px
        1280: {
            slidesPerView: 'auto',
            centeredSlides: false,
            spaceBetween: 30,
            slidesOffsetBefore: 75,
            slidesOffsetAfter: 75,
        }
    }
});
var swiper = new Swiper('.simpleSwiper', {
    modules: [Pagination,Autoplay,EffectFade],
    effect: 'fade',
    speed: 1500,
    keyboard: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
});

// Lightboxes
import GLightbox from 'glightbox';
const lightbox = GLightbox({});
lightbox.on('open', () => {
    const container = document.querySelector('.glightbox-container');
    container.dataset.slides = container.querySelectorAll('.gslide').length;
});

// Jumpy scroll to issues
 //history.scrollRestoration = "manual"

 //window.addEventListener('beforeunload', function(event) {
    //window.scrollTo(0, 0);
//});  

 // Count up stats
class countUp {
  constructor(el) {
    this.el = el;
    this.setVars();
    this.init();
  }

  setVars() {
    this.number = this.el.querySelectorAll("[data-countup-number]");
    this.hasAnimated = false; // Track animation state for this module
    this.observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const end = parseFloat(
          entry.target.dataset.countupNumber.replace(/,/g, "")
        );
        const decimals = this.countDecimals(end);
        if (entry.isIntersecting && !this.hasAnimated) {
          this.iterateValue(entry.target, end, decimals);
        }
      });
    }, this.observerOptions);
  }

  init() {
    if (this.number.length > 0) {
      this.number.forEach((el) => {
        // Check if the module hasn't animated yet
        if (!this.hasAnimated) {
          this.observer.observe(el);
        }
      });
    }
  }

  iterateValue(el, end, decimals) {
    const start = 0;
    const duration = 2500;
    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const elapsedPercent = (timestamp - startTimestamp) / duration;
      const easedProgress = Math.min(this.easeOutQuint(elapsedPercent), 1);
      let interimNumber = Math.abs(easedProgress * (end - start) + start);
      el.innerHTML = this.formatNumber(interimNumber, decimals);
      if (easedProgress < 1) {
        window.requestAnimationFrame(step);
      } else {
        // Animation is complete; set the hasAnimated flag to true
        this.hasAnimated = true;
      }
    };

    // requestAnimationFrame returns DOMHighResTimeStamp as a callback (used as timestamp)
    window.requestAnimationFrame(step);
  }

  easeOutQuad(x) {
    return 1 - Math.pow(1 - x, 3);
  }

  easeOutQuint(x) {
    return 1 - Math.pow(1 - x, 5);
  }

  countDecimals(val) {
    if (Math.floor(val) === val) return 0;
    return val.toString().split(".")[1].length || 0;
  }

  formatNumber(val, decimals) {
    return val.toLocaleString("en-US", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }
}

// Mutation Observer to watch for new elements with data-module="countup"
const mutationObserver = new MutationObserver((mutationsList, observer) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element && node.dataset.module === "countup") {
          node.dataset.module.split(" ").forEach(function () {
            new countUp(node);
          });
        }
      });
    }
  });
});

// Start observing the entire document for changes
mutationObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});

// Simplified version of attaching countUp instances
const dataModules = [...document.querySelectorAll('[data-module="countup"]')];

dataModules.forEach((element) => {
  element.dataset.module.split(" ").forEach(function () {
    new countUp(element);
  });
});

  

// apply active classes to home page hero links on page load
function addActiveClassWithDelay() {
  const links = document.querySelectorAll('.heroGalleryText a');
  let delay = 0; // Initial delay in milliseconds

  links.forEach((link) => {
      setTimeout(() => {
          link.classList.add('active');
      }, delay);

      delay += 800; // Increase the delay for the next link
  });
}

// Wait for the page to fully load before adding active classes
window.addEventListener('load', addActiveClassWithDelay);  
